<template>
  <!--footer-->
  <div class="box footer">
    <div class="wrap w1200 rdiv">
      <div class="partner">合作伙伴：<a href="http://www.smph.cn/">上海音乐出版社</a><a href="http://www.celap.org.cn/">浦东干部学院</a><a href="http://www.stiei.edu.cn/">上海电子信息职业技术学院</a><a href="https://www.honeywell.com.cn/">霍尼韦尔</a><a
        href="http://www.inesa-it.com/">云赛智联</a>
      </div>
      <div class="menu">
        <a href="">| 服务条款</a><a href="http://ydwl.inesa-it.com/newsall.asp" target="_blank">| 新闻资讯</a><a href="http://ydwl.inesa-it.com/about.asp?id=1" target="_blank">| 关于我们</a><a href="http://ydwl.inesa-it.com/HonorAll.asp" target="_blank">| 荣誉资质</a>
      </div>
      <div class="contact">
        <p><b>联系我们</b></p>
        <p class="mt5">电话：021-60319688</p>
        <p>地址：上海市吴中路8号（锦辉大厦）19楼</p>
        <p>传真：021-62316366</p>
        <p>QQ：23097543857</p>
        <p>网址： ydwl.inesa-it.com</p>
        <p>E-MAIL:ydwl@inesa-it.com</p>
      </div>
      <div class="ewm">
        <dl class="android">
          <dt><img src="./images/ewm_android.png" height="100" /></dt>
          <dd>Android版下载</dd>
        </dl>
        <dl class="ios">
          <dt><img src="./images/ewm_ios.png" height="100"/></dt>
          <dd>iPhone版下载</dd>
        </dl>
      </div>
    </div>
    <div class="text_end"><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402000736" style="color: #ddd; margin-right: 20px; display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="./images/gongan.png" style="float: left;"/>&nbsp;&nbsp;沪公网安备 31010402000736号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;| </a> 沪ICP备16000405号　　|　　信息网络视听许可证：0903018　　　白玉兰远程教育网　Copyright©上海仪电信息网络有限公司 {{year}}</div>
  </div>
  <!--/footer-->
</template>
<script>
export default {
  data () {
    return {
      year: ''
    }
  },
  created () {
    this.year = new Date().getFullYear()
  }
}
</script>
<style scoped>
  .footer{ height:440px; background:#373737;}
  .footer .partner{ height:80px; line-height:80px;color:#dddddd;}
  .footer .partner a{color:#dddddd; padding-right:9px; padding-left:9px;}
  .footer .partner a:hover{color:#fff;}
  .footer .menu{ height:245px; width:340px; border-right:1px solid #424242; position:absolute;top:90px;left:0;}
  .footer .menu a{ width:170px; height:40px; line-height:40px; float:left; display:block;color:#dddddd; font-size:12px;}
  .footer .menu a:hover{color:#fff;}
  .footer .contact{ width:430px; height:245px;top:90px;left:385px; position:absolute;color:#ddd; line-height:30px; border-right:1px solid #424242; }
  .footer .contact p b{ font-size:18px; font-weight:normal; padding-bottom:10px;}
  .footer .ewm .android{ text-align:center; position:absolute;top:90px;right:0;color:#ddd; line-height:40px;}
  .footer .ewm .ios{ text-align:center; position:absolute;top:90px;right:130px;color:#ddd; line-height:40px;}
  .footer .text_end{ height:64px; line-height:64px; text-align:center; color:#ddd; font-size:12px; border-top:1px solid #424242; margin-top:295px;}
</style>



// WEBPACK FOOTER //
// src/components/byl/footer/footer.vue